import { useCurrentUser } from '@/shared/composables/current-user'
import { getAuthenticatedMediaUrl } from '@/shared/utils/url'

export const getUserAvatarUrl = (id: string) => {
  const { currentUser } = useCurrentUser()
  const pathName = `/api/user/contacts/${currentUser.value && currentUser.value?.id === id ? currentUser.value.guid : id}/photo`

  return getAuthenticatedMediaUrl(pathName)
}
